<template>
    <div>
        <el-dialog
            title="更换设备"
            :visible.sync="dialogVisible"
            :close-on-click-modal='false'
            :close-on-press-escape='false'
            width="600px">
            <el-form ref="form" :model="form" :rules="rules" label-position="left" label-width="140px">
                <el-form-item label="原设备编号" prop="oldDeviceCode">
                    <div class="a-flex-cfsfs">
                        <span>{{ form.oldDeviceCode }}</span>
                        <span class="a-fs-12 a-c-999">本设备将从此站点解绑，恢复为未绑定站点的状态</span>
                    </div>
                </el-form-item>
                <el-form-item label="新设备编号" prop="newDeviceCode">
                    <div class="a-flex-cfsfs">
                        <el-input v-model="form.newDeviceCode" placeholder="请输入设备号"></el-input>
                        <span class="a-fs-12 a-c-999">新设备将替换原设备进入当前站点和资方的资产包</span>
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button class="plainBtn" @click="dialogVisible = false">取消</el-button>
                <el-button type="primary"  @click="submit">确定替换</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                dialogVisible: false,
                form: {
                    "newDeviceCode": '',
					"oldDeviceCode": ''
                },
                rules:{
                    newDeviceCode: [{required: true, message:'请输入新设备编号', trigger: 'blur'}]
                },
            };
        },
        watch:{
            dialogVisible (val) {
                if(this.$refs['form'] && !val){
                    this.$refs['form'].resetFields()
                }
            },
        },
        methods:{
            submit () {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        this.$Axios._post({
                            url: this.$Config.apiUrl.stationReplaceDevice,
                            params: {
                                ...this.form
                            }
                        }).then(res => {
                            if(res.result.code == 0){
                                this.dialogVisible = false
                                this.$message.success('操作成功')
                                this.$emit('change')
                            }else{
                                this.$message.error(res.result.message)
                            }
                        })
                    }
                })
            }
        }
    }
</script>